import { ImageName } from "@mcleod/images";
import { CommonDialogs, YesNoDialogProps } from "../CommonDialogs";
import { EmailSettings } from "./EmailSettings";
import { Layout } from "@mcleod/components";
import { TestEmailSettings } from "./TestEmailSettings";

export class TestEmailSettingsDisplayer {
    async displayInDialog(layoutEmailSettings: EmailSettings) {
        const layoutTestEmailSettings = await this.getTestEmailSettingsLayout(layoutEmailSettings);
        const sendEmail = await CommonDialogs.showYesNo(layoutTestEmailSettings, layoutTestEmailSettings.title,
            this.getDialogProps());
        if (sendEmail === true) {
            layoutTestEmailSettings.sendTestEmail();
        }
    }

    private getDialogProps(): Partial<YesNoDialogProps> {
        return {
            noButtonCaption: "Cancel",
            title: "Test Email Settings",
            yesButtonProps: {
                caption: "Send Test Message",
                imageName: ImageName.send
            }
        };
    }

    private async getTestEmailSettingsLayout(layoutEmailSettings: EmailSettings) {
        const layoutTestEmailSettings =
            await Layout.getLoadedLayout("common/email/TestEmailSettings") as TestEmailSettings;
        layoutTestEmailSettings.layoutEmailSettings = layoutEmailSettings;
        return layoutTestEmailSettings;
    }
}
